export default function({ rootState, dispatch, commit }, data) {
    commit('startedAuthentication')
    // POST /auth/login
    return dispatch('post', {
        url: '/provider/auth/verify',
        data,
        headers: {
            'Authorization': 'Bearer ' + data.token
        }
    }, {
        root: true
    })
    .then((result) => {
        console.log('verified')
        commit('finishedAuthentication')
        commit('verifiedJWT', result.payload)
        return result
    })
    .catch((error) => {
        commit('finishedAuthentication')
        commit('failedValidation')
        throw error
    })
}
